import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';

import Icon1xRate from '@/components/icons/videoplayer/PlaybackRate/1x.vue';
import Icon1_25xRate from '@/components/icons/videoplayer/PlaybackRate/1-25x.vue';
import Icon1_5xRate from '@/components/icons/videoplayer/PlaybackRate/1-5x.vue';
import Icon2xRate from '@/components/icons/videoplayer/PlaybackRate/2x.vue';

const cssClass = 'videoplayer';

export default /*@__PURE__*/_defineComponent({
  __name: 'PlaybackRate',
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const playbackRate = ref<number>(1);

const changeRate = () => {
  // eslint-disable-next-line default-case
  switch (playbackRate.value) {
    case 1:
      playbackRate.value = 1.25;
      break;
    case 1.25:
      playbackRate.value = 1.5;
      break;
    case 1.5:
      playbackRate.value = 2;
      break;
    case 2:
      playbackRate.value = 1;
      break;
  }

  emit('click', playbackRate.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([`${cssClass}__btn`, `${cssClass}__btn-rate`]),
    "aria-label": "Изменить скорость воспроизведения",
    onClick: changeRate
  }, [
    (playbackRate.value === 1)
      ? (_openBlock(), _createBlock(Icon1xRate, { key: 0 }))
      : (playbackRate.value === 1.25)
        ? (_openBlock(), _createBlock(Icon1_25xRate, { key: 1 }))
        : (playbackRate.value === 1.5)
          ? (_openBlock(), _createBlock(Icon1_5xRate, { key: 2 }))
          : (playbackRate.value === 2)
            ? (_openBlock(), _createBlock(Icon2xRate, { key: 3 }))
            : _createCommentVNode("", true)
  ], 2))
}
}

})